import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {} from "assets/jss/material-dashboard-react.js";
import { connect } from "react-redux";
import Button from "components/CustomButtons/Button.js";
import Actions from "redux/actions";
import api from "axios.js";
import { withRouter } from "react-router";
import MaterialTable from "components/MaterialTable.js";
import PubSub from "pubsub-js";
import { locataireListColumns } from "utils/columns";
import { Switch } from "@material-ui/core";
import axios from "axios";

class FormList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { active: true, tableLoading: false };
    this.actionsCache = null;
    this.actionsCacheKey = null;
    this.cancelSources = new Set();
    this._isMounted = false;
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.cancelAllRequests("LocatairesList unmounted");
    this.actionsCache = null;
    this.actionsCacheKey = null;
  }

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb);
    }
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source));
    } else {
      this.releaseCancelSource(source);
    }
    return promise;
  };

  getActions = () => {
    if (this.actionsCache && this.actionsCacheKey === this.props.canDelete) {
      return this.actionsCache;
    }
    const { canDelete } = this.props;
    const actions = [
      {
        icon: "edit",
        tooltip: "Modifier le locataire",
        onClick: (event, rowData) =>
          this.props.history.push(`/locataires/${rowData.id}/edit`),
      },
      {
        icon: "remove_red_eye",
        tooltip: "Voir les details du locataire",
        onClick: (event, rowData) =>
          this.props.history.push(`/locataires/${rowData.id}`),
      },
      canDelete && {
        icon: "delete",
        tooltip: "Supprimer le locataire",
        onClick: (event, rowData) =>
          PubSub.confirm({
            title: "Supprimer l'element ?",
            subtitle: "Cette action est irreversible.",
            onAgree: (_) =>
              this.props.dispatch(Actions.deleteLocataire(rowData.id)),
          }),
      },
      {
        icon: (p) => <Button color="primary">Nouveau Locataire</Button>,
        isFreeAction: true,
        onClick: (event) => this.props.history.push(`/locataires/new`),
      },
    ].filter(Boolean);
    this.actionsCache = actions;
    this.actionsCacheKey = canDelete;
    return this.actionsCache;
  };

  render() {
    const c = this.props.classes;
    const { active } = this.state;
    return (
      <div className={c.container}>
        <div className="fullW row align-c justify-e">
          <p
            style={{
              color: !active ? "green" : "unset",
              fontWeight: !active ? "bold" : "unset",
            }}
          >
            Anciens locataires
          </p>
          <Switch
            checked={active}
            onChange={(_) => {
              this.updateState({ active: !active }, () => {
                if (this.tableRef?.current?.onQueryChange) {
                  this.tableRef.current.onQueryChange();
                }
              });
            }}
          />
          <p
            style={{
              color: active ? "green" : "unset",
              fontWeight: active ? "bold" : "unset",
            }}
          >
            Dossier en cours
          </p>
        </div>
        <MaterialTable
          title=""
          isLoading={this.state.tableLoading}
          columns={locataireListColumns}
          actions={this.getActions()}
          data={(query) => {
            const requestedPage = query?.page || 0;
            const requestedPageSize = query?.pageSize || 20;
            const search = query?.search?.trim();
            const orderBy = query?.orderBy?.field;
            const orderDirection = query?.orderDirection;
            const filters =
              Array.isArray(query?.filters) && query.filters.length
                ? query.filters
                    .filter((f) => f?.value)
                    .map((f) => ({ field: f?.column?.field, value: f.value }))
                : undefined;
            const source = this.createCancelSource();
            this.updateState({ tableLoading: true });
            const params = {
              page: requestedPage + 1,
              pageSize: requestedPageSize,
              search: search || undefined,
              active,
              orderBy: orderBy || undefined,
              orderDirection: orderDirection || undefined,
              filters: filters ? JSON.stringify(filters) : undefined,
            };
            return api
              .get("/Locataire/listLite", { params, cancelToken: source.token })
              .then(({ data }) => {
                const payload = Array.isArray(data?.data)
                  ? data.data
                  : Array.isArray(data)
                  ? data
                  : [];
                const totalCount =
                  typeof data?.total === "number"
                    ? data.total
                    : typeof data?.totalCount === "number"
                    ? data.totalCount
                    : payload.length;
                this.updateState({ tableLoading: false });
                return { data: payload, page: requestedPage, totalCount };
              })
              .catch((error) => {
                if (axios.isCancel(error)) return { data: [], page: requestedPage, totalCount: 0 };
                this.updateState({ tableLoading: false });
                PubSub.notif({
                  txt: "Impossible de charger les locataires.",
                  color: "danger",
                });
                return { data: [], page: requestedPage, totalCount: 0 };
              })
              .finally(() => this.releaseCancelSource(source));
          }}
          onRowClick={(event, rowData) =>
            this.props.history.push(`/locataires/${rowData.id}`)
          }
          options={{
            filtering: true,
            pageSize: 20,
            actionsColumnIndex: -1,
          }}
          tableRef={this.tableRef}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {},
});

const mapStateToProps = (state) => ({
  locataires: state.reducer.locataires,
  canDelete: state.reducer.canDelete,
});
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(FormList))
);
